import InfoLayout from "./InfoLayout";

function Offer() {
  return (
    <InfoLayout title="Reklamní prostor">
      <p>
        Nabízíme možnost efektivního a cíleného reklamního prostoru ve webové aplikaci <strong>Tabata časovač</strong>. 
        Vaše video reklama se zobrazí vždy mezi výběrem cviků a spuštěním časovače. 
        Kromě toho lze reklamní sdělení nebo banner implementovat také do PDF, které si uživatel může nechat vygenerovat po dokončení tréninku.
      </p>

      <h2>Proč zvolit náš reklamní prostor?</h2>
      <ul>
        <li>
          <strong>Silnější dosah:</strong> Webová aplikace je okamžitě dostupná globálně, bez omezení App Store nebo Google Play a bez čekání na schválení.
        </li>
        <li>
          <strong>Efektivní formáty reklamy:</strong> Na rozdíl od mobilních aplikací umožňuje webová verze využívat video reklamy nebo reklamy v PDF, což zvyšuje zapojení uživatelů.
        </li>
        <li>
          <strong>Velké obrazovky = lepší viditelnost:</strong> Vaše reklama nebude ztracena na malém displeji – na monitorech, noteboocích či televizích zaujme maximálně.
        </li>
      </ul>

      <h2>Možnosti a kontakt</h2>
      <ul>
        <li>Umístění video reklamy mezi výběrem cviků a spuštěním časovače</li>
        <li>Reklamní banner nebo sdělení v PDF generovaném po tréninku</li>
        <li>Okamžitá dostupnost pro globální publikum</li>
      </ul>

      <p>
        Neváhejte nás kontaktovat pro podrobnější informace o cenách, podmínkách a možnostech umístění reklamy.
      </p>

      <p>
        <strong>Email:</strong> <a href="mailto:admin@tabataworkout.online">admin@tabataworkout.online</a>
      </p>
      <p>
        <strong>Provozovatel:</strong> <a href="https://www.tabataworkout.online" target="_blank" rel="noopener noreferrer">www.tabataworkout.online</a>
      </p>
    </InfoLayout>
  );
}

export default Offer;

